/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Ship_Dialog_TitleInputs */

const en_samples_ship_dialog_title = /** @type {(inputs: Samples_Ship_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Selected Samples As Shipped`)
};

const es_samples_ship_dialog_title = /** @type {(inputs: Samples_Ship_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar muestras seleccionadas como enviadas`)
};

/**
* | output |
* | --- |
* | "Mark Selected Samples As Shipped" |
*
* @param {Samples_Ship_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_ship_dialog_title = /** @type {((inputs?: Samples_Ship_Dialog_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Ship_Dialog_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_ship_dialog_title(inputs)
	return es_samples_ship_dialog_title(inputs)
});